export default (api) => {
    return {
        overview: {
            show: options => api.get('sam/overview', options)
        },
        top_challenges: {
            show: options => api.get('sam/top_challenges', options)
        },
        top_schools: {
            show: options => api.get('sam/top_schools', options)
        },
        teacher_view: {
            show: options => api.get('sam/teacher_view', options)
        },
        curriculum_coverage: {
            show: options => api.get('sam/curriculum_coverage', options)
        },
        math_skills: {
            show: options => api.get('sam/math_skills', options)
        },
        overall_engagement: {
            show: options => api.get('sam/overall_engagement', options)
        },
        schools_challenge_codes: options => api.get('sam/schools_challenge_codes', options),
        getAvgStudentCompletionBySchool: options => api.get('sam/completion/school', options),
        getAvgStudentCompletionByChallenge: options => api.get('sam/completion/challenge', options)
    }
}
